import i18n from "i18next";
import React from "react";
import ReactDOM from "react-dom/client";
import { initReactI18next } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { LoadingProvider } from "./contexts/LoadingContext";
import en from "./i18n/en.json";
import zhTW from "./i18n/zh-TW.json";
import "./index.css"; // Import Tailwind CSS
import store from "./redux/store";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "zh-TW": { translation: zhTW },
  },
  lng: localStorage.getItem("i18nextLng") || "zh-TW", // default language
  fallbackLng: "zh-TW", // fallback language
  interpolation: { escapeValue: false },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LoadingProvider>
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
          }}
        >
          <App />
        </BrowserRouter>
      </LoadingProvider>
    </Provider>
  </React.StrictMode>
);
